import * as React from 'react';
import UserInterface from '@app/Interface/UserInterface';
import { TableComposable, Tbody, Td, Th, Thead, Tr } from '@patternfly/react-table';
import UserDisplayName from './UserDisplayName';
import UserDisplayStatus from './UserDisplayStatus';
import UserRoleTypeChips from './UserRoleTypeChips';
import UserPermissionButtons from './UserPermissionButtons';
import UserRoleTypesInterface from '@app/Interface/UserRoleTypesInterface';
import FpuPermissionsComponentTypeInterface from '@app/Interface/FpuPermissionsComponentViewInterface';
import ProducerInterface from '@app/Interface/ProducerInterface';

interface UserPermissionsTableProps {
    producerId: number;
    producer: ProducerInterface;
    currentUser: UserInterface;
    users: UserInterface[];
    roleTypes: UserRoleTypesInterface[];
    changeView: (component: FpuPermissionsComponentTypeInterface, fetchUsers?: boolean) => void;
}

const UserPermissionsTable: React.FC<UserPermissionsTableProps> = ({ producerId, producer, currentUser, users, roleTypes, changeView }) => {

    const tableColumns = [
        "User",
        "Roles",
        "Status",
        ""
    ];

    return (
        <TableComposable
            arit-label="User Permissions"
            variant="compact"
            borders
            className="pf-u-mb-md"
        >
            <Thead>
                <Tr>
                    {tableColumns.map((column, columnIndex) => (
                        <Th key={columnIndex}>{column}</Th>
                    ))}
                </Tr>
            </Thead>
            <Tbody>
                {users.map((user) => (
                    <Tr key={user.id}>
                        <Td>
                            <UserDisplayName user={user} currentUser={currentUser} />
                        </Td>
                        <Td>
                            <UserRoleTypeChips user={user} producerId={producerId} roleTypes={roleTypes} />
                        </Td>
                        <Td>
                            <UserDisplayStatus user={user} />
                        </Td>
                        <Td>
                            {user.id !== currentUser.id && <UserPermissionButtons user={user} currentUser={currentUser} producerId={producerId} producer={producer} changeView={changeView} />}
                        </Td>
                    </Tr>
                ))}
            </Tbody>
        </TableComposable>
    );

}

export default UserPermissionsTable;